import {LatLngExpression} from 'leaflet'
import React, {useState} from 'react'
import {Marker, Popup} from 'react-leaflet'
import {BoxLink} from '../../common/router_links/BoxLink'
import {Box} from '../../webui/Box'
import {Card} from '../../webui/Card'
import {CardContent} from '../../webui/CardContent'
import {Divider} from '../../webui/Divider'
import {Switch} from '../../webui/inputs/Switch'
import {Stack} from '../../webui/Stack'
import {Typography} from '../../webui/Typography'
import {GenericMap} from '../location/map/GenericMap'
import {resolveBatteryStatusIcon} from './resolveBatteryStatusIcon'
import {BatteryStatusMarker} from './types/batteryStatusMarker'
import {HIGH_VOLTAGE_LIMIT, MEDIUM_VOLTAGE_LIMIT, resolveBatteryStatus} from './utils/batteryStatus'

interface Props {
  batteryStatuses: BatteryStatusMarker[]
}

const CENTER_OF_SWEDEN: LatLngExpression = [62.3875, 16.325556]

export const BatteryMap: React.FC<Props> = ({batteryStatuses}) => {
  const [hideHighBatteryStatus, setHideHighBatteryStatus] = useState(true)
  const [hideBatteryStatusZero, setHideBatteryStatusZero] = useState(true)

  const onToggleHideHighBatteryStatus = () => {
    setHideHighBatteryStatus((prevState) => !prevState)
  }

  const onToggleHideBatteryStatusZero = () => {
    setHideBatteryStatusZero((prevState) => !prevState)
  }

  const batteryStatusMarkers = batteryStatuses.filter(({voltage}) => {
    return (!hideHighBatteryStatus || voltage < HIGH_VOLTAGE_LIMIT) && (!hideBatteryStatusZero || voltage !== 0)
  })
  return (
    <Box p={2}>
      <Card variant="outlined">
        <CardContent>
          <Stack direction={{xs: 'column', sm: 'row'}} spacing={2} alignItems="center" justifyContent="space-between" flexWrap="wrap">
            <Stack direction="row" spacing={3}>
              <Switch label={'Show high battery status'} value={!hideHighBatteryStatus} onChange={onToggleHideHighBatteryStatus} />
              <Switch label={'Show battery status 0'} value={!hideBatteryStatusZero} onChange={onToggleHideBatteryStatusZero} />
            </Stack>

            <Divider orientation="vertical" flexItem sx={{display: {xs: 'none', sm: 'block'}}} />

            <Typography variant="body2" sx={{whiteSpace: 'nowrap'}}>
              High voltage limit: <strong>{HIGH_VOLTAGE_LIMIT / 1000}V</strong>, Medium voltage limit: <strong>{MEDIUM_VOLTAGE_LIMIT / 1000}V</strong>
            </Typography>
          </Stack>
        </CardContent>
      </Card>

      <Box mt={2}>
        <GenericMap height="700px" initialPosition={CENTER_OF_SWEDEN} zoom={5}>
          {batteryStatusMarkers.map((marker) => (
            <Marker
              icon={resolveBatteryStatusIcon(resolveBatteryStatus(marker))}
              key={marker.id}
              position={[marker.coordinates.lat, marker.coordinates.long]}
            >
              <Popup>
                <BoxLink boxId={marker.id} linkText={marker.title} />
              </Popup>
            </Marker>
          ))}
        </GenericMap>
      </Box>
    </Box>
  )
}
